import { useEffect, useState } from "react";
import Campo from "../../../components/Campo";
import { Instituicao } from "../../../model/Instituicao";
import styles from "./styles.module.css";
import {
  cepMask,
  cnpjMask,
  numberMask,
  phoneMask,
} from "../../../controllers/Masks";
import { useMask } from "@react-input/mask";
import VerificaForm from "../../../controllers/VerificaForm";
import CampoSelect from "../../../components/Campo/CampoSelect";
import listarCidades from "../../../services/listarCidades";

type Props = {
  passarPagina: Function;
  setInstituicao: React.Dispatch<React.SetStateAction<Instituicao | undefined>>;
};

function CadastroInstituicao({ passarPagina, setInstituicao }: Props) {
  const [nomeInstituicao, setNome] = useState("");
  const [cnpjInstituicao, setCnpj] = useState("");
  const [emailInstituicao, setEmail] = useState("");
  const [telefoneInstituicao, setTelefone] = useState("");

  const [cepEndereco, setCep] = useState("79200-000");
  const [numeroEndereco, setNumero] = useState("");
  const [ruaEndereco, setRua] = useState("");
  const [bairroEndereco, setBairro] = useState("");
  const [cidadeEndereco, setCidade] = useState("Aquidauana");
  const [estadoEndereco, setEstado] = useState("MS");
  const [complementoEndereco, setComplemento] = useState("");

  const [listaCidades, setListaCidades] = useState(["", "Aquidauana"]);

  useEffect(() => {
    const atualizarListaCidades = async () => {
      try {
        const response = await listarCidades(estadoEndereco);
        const cidades = response.map((c: any) => {
          return c.nome;
        });

        setListaCidades(cidades);
        if (estadoEndereco === "MS") {
          setCidade("Aquidauana");
        } else {
          setCidade(listaCidades[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      }
    };
    atualizarListaCidades();
  }, [estadoEndereco]);

  return (
    <>
      <h2>
        1. Cadastre Informações sobre a sua <strong>Instituição</strong>
      </h2>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Dados da Instituição:</h3>
      <div className={styles.gridCampos}>
        <Campo
          title="Nome da Instituição"
          type="text"
          placeholder="Nome da sua Instituição"
          maxLength={64}
          required={true}
          customValidity="Preencha com o nome da sua Instituição"
          setter={setNome}
          value={nomeInstituicao}
        ></Campo>

        <Campo
          title="CNPJ"
          type="text"
          placeholder="00.000.000/0000-00"
          minLength={18}
          required={true}
          customValidity="Preencha o CNPJ da sua Instituição"
          setter={setCnpj}
          value={cnpjInstituicao}
          mask={useMask(cnpjMask)}
        ></Campo>

        <Campo
          title="E-mail"
          type="email"
          placeholder="Digite seu email"
          maxLength={64}
          required={true}
          customValidity="Preencha o E-mail da sua Instituição"
          setter={setEmail}
          value={emailInstituicao}
        ></Campo>

        <Campo
          title="Telefone"
          type="tel"
          placeholder="(DDD)90000-0000"
          minLength={14}
          required={true}
          customValidity="Preencha o Telefone de contato da sua Instituição"
          setter={setTelefone}
          value={telefoneInstituicao}
          mask={useMask(phoneMask)}
        ></Campo>
      </div>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Endereço da Instituição:</h3>
      <div className={styles.gridCampos}>
        <Campo
          title="CEP"
          type="text"
          placeholder="00000-000"
          minLength={9}
          required={true}
          customValidity="Preencha com o CEP da sua Instituição"
          setter={setCep}
          value={cepEndereco}
          mask={useMask(cepMask)}
        ></Campo>
        <CampoSelect
          title="Estado"
          setter={setEstado}
          value={estadoEndereco}
          required
        >
          <option value="AC">Acre (AC)</option>
          <option value="AL">Alagoas (AL)</option>
          <option value="AP">Amapá (AP)</option>
          <option value="AM">Amazonas (AM)</option>
          <option value="BA">Bahia (BA)</option>
          <option value="CE">Ceará (CE)</option>
          <option value="DF">Distrito Federal (DF)</option>
          <option value="ES">Espírito Santo (ES)</option>
          <option value="GO">Goiás (GO)</option>
          <option value="MA">Maranhão (MA)</option>
          <option value="MT">Mato Grosso (MT)</option>
          <option value="MS">Mato Grosso do Sul (MS)</option>
          <option value="MG">Minas Gerais (MG)</option>
          <option value="PA">Pará (PA)</option>
          <option value="PB">Paraíba (PB)</option>
          <option value="PR">Paraná (PR)</option>
          <option value="PE">Pernambuco (PE)</option>
          <option value="PI">Piauí (PI)</option>
          <option value="RJ">Rio de Janeiro (RJ)</option>
          <option value="RN">Rio Grande do Norte (RN)</option>
          <option value="RS">Rio Grande do Sul (RS)</option>
          <option value="RO">Rondônia (RO)</option>
          <option value="RR">Roraima (RR)</option>
          <option value="SC">Santa Catarina (SC)</option>
          <option value="SP">São Paulo (SP)</option>
          <option value="SE">Sergipe (SE)</option>
          <option value="TO">Tocantins (TO)</option>
        </CampoSelect>
        <CampoSelect title="Cidade" setter={setCidade} value={cidadeEndereco}>
          {listaCidades &&
            listaCidades.map((cidade, index) => (
              <option value={cidade} key={index}>
                {cidade}
              </option>
            ))}
        </CampoSelect>
        <Campo
          title="Bairro"
          type="text"
          placeholder="Bairro de sua Instituição"
          maxLength={64}
          required={true}
          customValidity="Preencha com o Bairro da sua Instituição"
          setter={setBairro}
          value={bairroEndereco}
        ></Campo>
        <Campo
          title="Rua"
          type="text"
          placeholder="Rua da sua Instituição"
          maxLength={64}
          required={true}
          customValidity="Preencha com a rua da sua Instituição"
          setter={setRua}
          value={ruaEndereco}
        ></Campo>
        <Campo
          title="Numero"
          type="text"
          placeholder="Numero do Imóvel"
          required={true}
          customValidity="Preencha com o numero do Imóvel"
          setter={setNumero}
          value={numeroEndereco}
          mask={useMask(numberMask)}
        ></Campo>
        <Campo
          title="Complemento"
          type="text"
          placeholder="Complemento do Imóvel"
          maxLength={128}
          required={false}
          customValidity="Preencha com o Complemento"
          setter={setComplemento}
          value={complementoEndereco}
        ></Campo>
      </div>
      <div className="flex justify-end">
        <button
          className={styles.passarTelaBtn}
          onClick={(e) => {
            if (VerificaForm(e.currentTarget.form)) {
              setInstituicao({
                nome: nomeInstituicao,
                cnpj: cnpjInstituicao,
                email: emailInstituicao,
                telefone: telefoneInstituicao,
                endereco: {
                  cep: cepEndereco,
                  estado: estadoEndereco,
                  cidade: cidadeEndereco,
                  bairro: bairroEndereco,
                  rua: ruaEndereco,
                  numero: numeroEndereco,
                  complemento: complementoEndereco,
                },
              });

              passarPagina(1);
            }
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </>
  );
}

export default CadastroInstituicao;
